export class Registro {
    id: number;
    urlAudio: string;
    detectadas: string;
    transcripcion:string;
    fiable:string;
    aprobado:boolean;
    created:Date;
    updated:Date;
}